import { formatDateRange as formatDateRangeTZ } from "./timezone";

export const formatCurrency = (value) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  }).format(value || 0);
};

export const formatPercent = (value) => {
  return `${parseFloat(value || "0").toFixed(2)}%`;
};

/**
 * Format date ranges according to business rules:
 * 1. Don't show year unless it's not the current year
 * 2. If date range is one day, hide the date range entirely
 *
 * Now uses centralized timezone utilities to properly handle UTC timestamps.
 */
export const formatDateRange = formatDateRangeTZ;

export const getPerformanceClass = (value) => {
  if (value > 0) return "text-green-600 dark:text-green-400";
  if (value < 0) return "text-red-600 dark:text-red-400";
  return "text-gray-600 dark:text-gray-400";
};

export const getPerformanceColor = (value) => {
  if (value > 0) return "var(--color-positive)";
  if (value < 0) return "var(--color-negative)";
  return "var(--stat-label-color)";
};

/**
 * Decode HTML entities in text (e.g., &#39; -> ', &amp; -> &)
 * Useful for displaying text from external sources like StockTwits
 */
export const decodeHtmlEntities = (text) => {
  if (!text) return text;
  const textarea = document.createElement("textarea");
  textarea.innerHTML = text;
  return textarea.value;
};
